import { useMemo } from 'react';

export function useFilteredTasks(project, filters) {
    const { filterByAssignee = new Set(), filterBy, user } = filters;

    return useMemo(() => {
        if (!project.tasks) return [];

        // Create a new array for filtering
        let tasks = [...project.tasks];

        // Apply filters
        tasks = tasks.filter(task =>
            filterByAssignee.size === 0 ||
            (task.assignee && filterByAssignee.has(task.assignee.id))
        );

        switch (filterBy) {
            case 'created':
                tasks = tasks.filter(task => task.reporterId === user.id);
                break;
            case 'priority':
                tasks = tasks.filter(task =>
                    task.priority === 'urgent' || task.priority === 'high'
                );
                break;
            case 'dueThisWeek':
                tasks = tasks.filter(task =>
                    task.dueDate &&
                    task.dueDate >= project.week.weekBoundaries.start &&
                    task.dueDate <= project.week.weekBoundaries.end
                );
                break;
            default:
                break;
        }

        return tasks;

    }, [project.tasks, filterByAssignee, filterBy]);
}

export function useSortedTasks(tasks, sortBy) {

    return useMemo(() => {
        if (!tasks) return [];
        const sortedTasks = [...tasks];
        const priorityOrder = {
            'urgent': 0,
            'high': 1,
            'medium': 2,
            'low': 3,
            'no_priority': 4
        };
            switch (sortBy) {
                case 'created':
                sortedTasks.sort((a, b) =>
                    new Date(a.createdAt) - new Date(b.createdAt)
                );
                break;
            case 'priority':
                sortedTasks.sort((a, b) =>
                    priorityOrder[a.priority] - priorityOrder[b.priority]
                );
                break;
            case 'due':
                sortedTasks.sort((a, b) => {
                    if (!a.dueDate) return 1;
                    if (!b.dueDate) return -1;
                    return new Date(a.dueDate) - new Date(b.dueDate);
                });
                break;
            case 'updated':
                sortedTasks.sort((a, b) =>
                    new Date(b.updatedAt) - new Date(a.updatedAt)
                );
                break;
            case 'manual':
                sortedTasks.sort((a, b) => a.position - b.position);
                break;
            default:
                break;
            }

            return sortedTasks;
    }, [tasks, sortBy]);
}